import { useIntl } from 'react-intl';
import Image from 'next/image';
import { messages } from '../messages';

export const DiscountFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <footer className="tw-p-4 tw-w-full">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 min-[992px]:tw-grid-cols-1 min-[1200px]:tw-grid-cols-[1fr_0.7fr_1fr] -tw-mx-4">
        <div className="tw-p-4 tw-col-auto md:tw-col-span-2 min-[992px]:tw-col-auto min-[1200px]:tw-col-auto">
          <p className="tw-mb-4">
            {formatMessage(messages['redeem.discount.page.footer.1'])}
          </p>
        </div>

        <div className="tw-p-4">
          <div style={{ position: 'relative', width: '100%', height: 'auto' }}>
            <Image
              src="/images/example-certificate-verified.png"
              alt="Example Verified Certificate"
              width={400}
              height={300}
              className="img-fluid"
              style={{ width: '100%', height: 'auto' }}
            />
          </div>
        </div>
        <div className="tw-p-4">
          <h3 className="tw-text-[22px] tw-mb-2">
            {formatMessage(messages['redeem.discount.page.footer.2.heading'])}
          </h3>
          <p className="tw-mb-4">
            {formatMessage(messages['redeem.discount.page.footer.2.p1'])}
          </p>
          <p className="tw-mb-4">
            {formatMessage(messages['redeem.discount.page.footer.2.p2'])}
          </p>
          <p className="tw-mb-4">
            {formatMessage(messages['redeem.discount.page.footer.2.p3'])}
          </p>
        </div>
      </div>
    </footer>
  );
};
